<template>
    <ClientOnly>
        <Lightbox
            v-if="isWatchingVideo"
            @close="isWatchingVideo = false"
        >
            <Oembed src="https://vimeo.com/1064940070" />
        </Lightbox>
    </ClientOnly>
</template>

<script>
// eslint-disable-next-line
definePageMeta({
    layout: 'cms',
});

import { defineAsyncComponent } from 'vue';

const Oembed = defineAsyncComponent(() => import('@/components/media/oembed'));
const Lightbox = defineAsyncComponent(() => import('@/components/modals/lightbox'));

export default {
    name: 'HeadlessPage', 
    components: { Oembed, Lightbox },
    data() {
        return {
            isWatchingVideo: false
        };
    },
    mounted() {
        this.$bus.on('cms:headless-video', this.headlessVideo);
        window.addEventListener('click', this.onClick);
    },
    methods: {
        onClick({ target }) {
            if (target.tagName !== 'A') target = target.closest('a');
            if (target && target.href && target.href.includes('#headless')) {
                const id = target.href.split('#')[1];
                this.$bus.emit('tab:select', id);
            }
        },
        headlessVideo({ target }) {
            if (this.isWatchingVideo) return;
            if (target.tagName !== 'BUTTON') target = target.closest('button');
            this.isWatchingVideo = true;
            this.$track.event('Marketing Video Played', {
                'button_cta': target.innerText,
                'button_placement': target.dataset.placement || 'hero'
            });
        }
    }
};
</script>
